import { parseBackend } from "./parseBackEnd";
import { parseFrontEnd } from "./parseFrontEnd";

// Function to handle scraping retailer data in parallel
export const scrapeRetailersInParallel = async (
  retailersToScrape: any[],
  productTitle: string
) => {
  try {
    // Map over the retailers and create a promise for each scraping task
    const scrapingTasks = retailersToScrape.map(async (retailer) => {
      if (retailer.scrape_location === "WEB") {
        try {
          // Parse the retailer data from the web
          await parseFrontEnd(retailer, productTitle);
        } catch (error) {
          console.error(`Error parsing WEB retailer:`, error);
        }
      } else if (retailer.scrape_location === "BACKEND") {
        try {
          // Parse the retailer data from the backend
          await parseBackend(retailer, productTitle);
        } catch (error) {
          console.error(`Error parsing BACKEND retailer:`, error);
        }
      }
    });

    // Wait for all tasks to complete
    await Promise.all(scrapingTasks);
  } catch (error) {
    console.error("Error scraping retailers in parallel:", error);
  }
};
